// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.v-list-item__content:has(.delta--added-highlight),div.v-list-item__content:has(.delta--changed-highlight),div.v-list-item__content:has(.delta--removed-highlight),span:has(.delta--added-highlight),span:has(.delta--changed-highlight),span:has(.delta--removed-highlight){overflow:visible!important}.delta-parent-overflow{overflow:visible!important}", ""]);
// Exports
module.exports = exports;
